angular.module('impactx.redirectandsave').service('RedirectAndSaveService', RedirectAndSaveService);

RedirectAndSaveService.$inject = ['$mdDialog'];

function RedirectAndSaveService($mdDialog)
{
    return {
        showRedirectAndSaveDialog: function(saveFunction, noSaveFunction, event, message, saveLabel, abortLabel, noSaveLabel, mustSave)
        {
            $mdDialog.show({
                    controller: "RedirectAndSaveCtrl",
                    controllerAs: "redirectAndSaveCtrl",
                    templateUrl: "shared/redirectandsavedialog/templates/redirectandsave.tmpl.html",
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        saveLabel: saveLabel,
                        noSaveLabel: noSaveLabel,
                        message: message,
                        abortLabel: abortLabel,
                        mustSave: mustSave
                    }
                })
                .then(function ()
                {
                    saveFunction();
                }, function (answer)
                {
                    if (answer != "abort" && !mustSave)
                    {
                        noSaveFunction();
                    }
                });
        }
    }
}